export default __webpack_public_path__ + "static/media/MarketResearch360DevPro.26336a6d.png";